export default __webpack_public_path__ + "static/media/Jager-auf-def-Lauer.25a4b94c.mp3";